import videojs from 'video.js';

import { Event } from '@src/types/event';

const FullscreenToggle = videojs.getComponent('FullscreenToggle');

class CustomFullscreenToggle extends FullscreenToggle {
  handleClick(evt: videojs.EventTarget.Event) {
    this.player().trigger(
      this.player().isFullscreen() ? Event.INLINESCREEN : Event.FULLSCREEN
    );

    super.handleClick(evt);
  }
}

// override video.js original FullscreenToggle
videojs.registerComponent('FullscreenToggle', CustomFullscreenToggle);

export default CustomFullscreenToggle;
